module.exports = __webpack_public_path__ + "img/volunteer-3.e31eaa7b.jpg";